import { DefaultButtonsConfig } from './../../base-models/default-buttons-config';
import { DefaultListFilter } from './../default-list-filter/default-list-filter.component';
import { IDefaultListFilter } from './default-list-filter.interface';
import { BaseDefaultListFilterComponent } from '../default-list-filter/base-default-list-filter-component';
import { FilterContainerDirective } from './filter-container.directive';
import { DefaultListType } from './../../base-models/default-list-type';
import { TranslateService } from '@ngx-translate/core';
import { UserService } from './../../base-services/user.service';
import { BaseContainerService } from './../../base-classes/containers/services/base-container-service';
import { BaseListComponent } from './../../base-classes/base-list-component';
import { BaseDataService } from './../../base-services/base-data.service';
import { ActivatedRoute } from '@angular/router';
import { BaseEntity } from './../../base-models/base-entity';
import { Component, OnInit, Input, ViewChild, ComponentFactoryResolver, Optional, Inject, Output, EventEmitter } from '@angular/core';
//import { NotifierService } from 'angular-notifier';
// import { NotificationsService } from 'angular2-notifications';
import { ModalService } from '../../base-services/modal.service';
import { ModelDataService } from '../../base-services/model-data.service';
import { TableContextMenuItem } from '../default-table/table-context-menu-item';
import { ParentProperty } from '../../base-models/parent-property';
// import { ToastrService } from 'ngx-toastr';
import { NotificationService } from '../../base-services/notification-service';
import { ModelData } from '../../base-models/model-data';
import { TableContextMenu } from '../default-table/table-context-menu';

@Component({
  selector: 'yt-fw-base-default-list',
  template: ''
})
export class BaseDefaultListComponent<T extends BaseEntity> extends BaseListComponent<T> implements OnInit {

  // constructor(
  //   protected activatedRoute: ActivatedRoute,
  //   protected baseDataService: BaseDataService,
  //   protected containerService: BaseContainerService<T>,
  //   protected userService: UserService,
  //   protected notificationsService: NotificationsService,
  //   protected translateService: TranslateService,
  //   protected modalService: ModalService,
  //   protected componentFactoryResolver: ComponentFactoryResolver,
  //   @Optional() @Inject(ModelDataService) protected modelDataService?: ModelDataService,
  // ) {
  //   super(activatedRoute, baseDataService, containerService, userService, notificationsService, translateService, modalService, modelDataService);
  // }

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected baseDataService: BaseDataService,
    protected containerService: BaseContainerService<T>,
    protected userService: UserService,
    protected toastrService: NotificationService,
    protected translateService: TranslateService,
    protected modalService: ModalService,
    protected componentFactoryResolver: ComponentFactoryResolver,
    @Optional() @Inject(ModelDataService) protected modelDataService?: ModelDataService,
  ) {
    super(activatedRoute, baseDataService, containerService, userService, toastrService, translateService, modalService, modelDataService);
  }


  @Input() CondensedTable: boolean = false;
  //@Input() Type: DefaultListType = DefaultListType.List;

  @Output() TableContextMenuItemClicked = new EventEmitter();
  @Output() TableSelectItemFormatDetailClicked = new EventEmitter();
  @Output() TableContextMenuClicked = new EventEmitter();
  hasDetail1Access: boolean = false;
  MainTableConfig = {};
  DetailTableConfig: any = {};
  DetailTableConfig1: any = {};
  TreeViewConfig = {};
  currentPage: number = 1;
  @Input() pageSize: number = 40;
  totalRecords: number = 0;
  @Input() showPagination: boolean = false;
  //@ViewChild(FilterContainerDirective) filterContainer: FilterContainerDirective;

  ngOnInit() {
    super.ngOnInit();
  }


  ngAfterViewInit(){
    if(this.filterComponent && this.modelData.LoadOnInit)
    setTimeout(() => {
      //this.LoadMainItems(false, this.filterComponent.filterFormGroup.value);
      this.filterComponent.ApplyFilter();
    })
    if (this.modelData.MainList.Pagination) {
      this.getTotalRecords();
    }
  }

  OnModelDataLoaded(){
    super.OnModelDataLoaded();

    this.MainTableConfig = {
      EditIcon: {
        Visible: this.modelData.MainList.EnableEdit,
        Icon: 'fa fa-fw item-icon ' + this.modelData.MainList.EditIcon
      },
      DeleteIcon: {
        Visible: this.modelData.MainList.EnableDelete
      },
      PrintIcon: {
        Visible: this.modelData.MainList.EnablePrint && this.modelData.MainList.PrintName
      },
      DefaultSortKey: this.modelData.MainList.SortBy,
      DefaultSortReverse: this.modelData.MainList.SortReverse,
      ShowIndex: false,
      ShowDefaultListButtons: this.modelData.MainList.DefaultListButtonsOptions.ShowDefaultListButtons,
      Height: '100w',
      //ShowCheckBoxes: true,
      ShowCheckBoxes: this.modelData.MainList.ShowCheckBoxes,
      DefaultListButtonsConfig: this.modelData.MainList.DefaultListButtonsConfig,
      PrintName: this.modelData.MainList.PrintName,
      CanHideDetailTable: (this.modelData.MainList.DetailList.length == 0) ? false : true,
      BreadCrumble: this.modelData.BreadcrumbLabel,
      ColumnBorderEven: this.modelData.MainList.TableColumnBorderEven,
      ColumnBorderOdd: this.modelData.MainList.TableColumnBorderOdd,
      ShowColumnRatioOptions: this.modelData.MainList.EnableColumnRatioOptions !== false,
    }  

    this.DetailTableConfig = {
      EditIcon: {
        Visible: false
      },
      DeleteIcon: {
        Visible: false
      },
      PrintIcon: {
        Visible: false
      },
      DefaultSortKey: 'ID',
      DefaultSortReverse: false,
      ShowIndex: false,
      ShowDefaultListButtons: false,
      Height: '100w',
      IsModal: false,
      CanHideDetailTable: false,
      BreadCrumble: this.modelData.BreadcrumbLabel + "-" + this.translateService.get("FW.STAVKE.PLURAL")["value"],
      //DefaultListButtonsConfig: new DefaultButtonsConfig(),
      DefaultListButtonsConfig: this.modelData.MainList.DefaultListButtonsConfig
    }
    var detailModel1 = this.modelData.MainList.DetailList.length > 1
      ? this.modelData.MainList.DetailList[1]
      : null;

    if (detailModel1) {
      detailModel1.DefaultListButtonsConfig.DeleteAllButtonConfig.Visible = false;
      detailModel1.DefaultListButtonsConfig.PrintButtonConfig.Visible = false;
    }


    this.DetailTableConfig1 = {
      EditIcon: {
        Visible: detailModel1 && detailModel1.EnableEdit === true
        //Visible: true
      },
      DeleteIcon: {
        Visible: detailModel1 && detailModel1.EnableDelete === true
      },
      PrintIcon: {
        Visible: detailModel1 && !!detailModel1.PrintName
      },
      DefaultSortKey: detailModel1 && detailModel1.SortBy ? detailModel1.SortBy : 'ID',
      DefaultSortReverse: detailModel1 && detailModel1.SortReverse ? detailModel1.SortReverse : false,
      ShowIndex: false,
      ShowDefaultListButtons:
        (detailModel1 &&
          detailModel1.DefaultListButtonsOptions &&
          typeof detailModel1.DefaultListButtonsOptions.ShowDefaultListButtons !== 'undefined')
          ? detailModel1.DefaultListButtonsOptions.ShowDefaultListButtons
          : (detailModel1 && (detailModel1.EnableEdit || detailModel1.EnableDelete || !!detailModel1.PrintName)),
      Height: '100w',
      IsModal: false,
      CanHideDetailTable: false,
      BreadCrumble: this.modelData.BreadcrumbLabel + '-',
      DefaultListButtonsConfig:
        detailModel1 && detailModel1.DefaultListButtonsConfig
          ? detailModel1.DefaultListButtonsConfig
          : {
            //            DeleteAllButtonConfig: { Enable: false, Visible: false },
            AddButtonConfig: { Enable: detailModel1 && detailModel1.EnableEdit === true, Visible: detailModel1 && detailModel1.EnableEdit === true },
            DeleteButtonConfig: { Enable: detailModel1 && detailModel1.EnableDelete === true, Visible: detailModel1 && detailModel1.EnableDelete === true },
            PrintButtonConfig: { Enable: detailModel1 && !!detailModel1.PrintName, Visible: detailModel1 && !!detailModel1.PrintName }
          }
    };


    this.TreeViewConfig = {
      ShowDefaultListButtons: true,
      EditIcon: {
        Visible: true
      },
      DeleteIcon: {
        Visible: true
      },
      //DefaultListButtonsConfig: new DefaultButtonsConfig()
      DefaultListButtonsConfig: this.modelData.MainList.DefaultListButtonsConfig
    }

    //create filter
    if(this.modelData.MainList.DefaultListFilterComponent){
      let componentFactory = this.componentFactoryResolver.resolveComponentFactory(this.modelData.MainList.DefaultListFilterComponent);
      let componentRef = this.filterContainer.viewContainerRef.createComponent(componentFactory);
      (<DefaultListFilter>componentRef.instance).FilterApplied
        .subscribe(filter => {
          if (this.modelData.MainList.Pagination) {
            this.currentPage = 1;
          }
          this.LoadMainItems(true, (<DefaultListFilter>componentRef.instance).filterFormGroup.value);
        })

      this.filterComponent = (<DefaultListFilter>componentRef.instance);
    }
  }

  AddItem(){
    //alert('Add item');    
    
    this.containerService.AddItem(this.modelData, this._parentPropertyName ? new ParentProperty(this._parentPropertyName, this._parentPropertyValue) : null);
    //alert("Add item base default list");
  }

  AddDetailItem() {
    const detailModelData1 = new ModelData(this.userService);
    const detailListItem = this.modelData.MainList.DetailList[1];
    detailModelData1.MainList = detailListItem;
    const parentPropName = detailListItem.ParentProperty;
    const parentPropValue = this.parentID;
    const parentPropParameter = new ParentProperty(parentPropName, parentPropValue);
    detailModelData1.UpdateComponent = detailListItem.UpdateComponent;
    //detailModelData1.MainList.CloseAfterSave=true;
    //this.containerService.AddDetailItem(detailModelData1, null);
    this.containerService.AddDetailItem(detailModelData1, parentPropParameter);

  }

  EditItem(item: T){       
    this.containerService.EditItem(this.modelData, item.ID);
    // this.containerService.EditItem(this.modelData, item.ID, item.Useridlk);
  }
  EditDetailItem(item: T) {
    if (this.modelData.MainList.DetailList.length > 1) {
      var detailModelData1 = new ModelData(this.userService);
      const detailListItem = this.modelData.MainList.DetailList[1];
      const parentPropName = detailListItem.ParentProperty;
      const parentPropValue = this.parentID;
      detailModelData1.UpdateComponent = detailListItem.UpdateComponent;
      detailModelData1.MainList = detailListItem;
      const parentPropParameter = new ParentProperty(parentPropName, parentPropValue);
      this.containerService.EditDetailItem(detailModelData1, item.ID, parentPropParameter);
    }
  }

  DeleteDetailItem(item: T) {
    this.translateService.get(['FW.ACTION.DELETE.ACTIONNAME', 'FW.ACTION.DELETE.MESSAGE.SUCCESS', 'FW.ACTION.DELETE.QUESTION', 'FW.ACTION.DELETE.MESSAGE.LOCK'])
      .subscribe(translate => {
        this.baseDataService.GetByID(this.modelData.MainList.DetailList[1].ModelName, item.ID, this.modelData.MainList.DetailList[1].ModelClass)
          .subscribe(data => {
            if (data && data["Useridlk"] && data["Useridlk"] != null) {
              //this.notificationsService.warn(translate['FW.ACTION.DELETE.ACTIONNAME'], translate['FW.ACTION.DELETE.MESSAGE.LOCK'])
              this.toastrService.warning(translate['FW.ACTION.DELETE.ACTIONNAME'], translate['FW.ACTION.DELETE.MESSAGE.LOCK']);
            }
            else {
              const confirmationPromise = this.CustomDeleteConfirmation
                ? this.CustomDeleteConfirmation(item)
                : this.showDeleteConfirmationDialog(item);

              confirmationPromise.then(result => {
                if (result) {
                  this.baseDataService.Delete(this.modelData.MainList.DetailList[1].ModelName, item.ID)
                    .subscribe(data => {
                      this.OnDetail1ItemDeleted(data);
                      //this.notificationsService.success(translate['FW.ACTION.DELETE.MESSAGE.SUCCESS'], "Slog");
                      this.toastrService.success(translate['FW.ACTION.DELETE.MESSAGE.SUCCESS'], "Slog");
                      if (this.detail1Items.size > 0) this.SelectDetailItem(this.detail1Items[0])
                    })
                }
              }, (reason) => {

              })
              //}
            }
          })
      })
  }


  ContextMenuItemClicked(contextMenuItem: TableContextMenuItem){
    this.TableContextMenuItemClicked.emit(contextMenuItem);
  }

  ContextMenuOfTableClicked(contextMenuOfTable: TableContextMenu) {
    this.TableContextMenuClicked.emit(contextMenuOfTable);
  }

  SelectItemFormatDetailClicked(item: T){
    this.TableSelectItemFormatDetailClicked.emit(item);
  }

  ngOnDestroy() {
    super.ngOnDestroy();
    if (this.filterComponent) {
        this.filterComponent = null; // Uklonite referencu
        this.filterContainer.viewContainerRef.clear(); // Očistite ViewContainerRef
    }

    this.MainTableConfig = null;
    this.DetailTableConfig = null;
    this.DetailTableConfig1 = null;
    this.TreeViewConfig = null;
  }
  onSearchServer(searchTerm: string = this.searchKeyword) {
    this.searchKeyword = searchTerm;
    this.currentPage = 1;

    const filter = {
      ...this.filterComponent.filterFormGroup.value,
      Search: searchTerm
    };

    console.log('searchTerm:', searchTerm);
    console.log('this.searchKeyword:', this.searchKeyword);
    console.log('filter:', filter);

    this.LoadMainItems(true, filter);
  }



  onClearServerSearch() {
    this.searchKeyword = '';
    this.currentPage = 1;

    const filter = {
      ...this.filterComponent.filterFormGroup.value,
      Search: ''
    };

    this.LoadMainItems(true, filter);
  }

  onSearchKeyword() {
    this.onSearchServer(this.searchKeyword);
  }

  onPageChanged(page: number) {
    this.currentPage = page;

    const filter = {
      ...this.filterComponent.filterFormGroup.value,
      Search: this.searchKeyword
    };

    this.LoadMainItems(true, filter);
  }

onDetailVisibilityChanged(v: boolean) {
  if (this.modelData.MainList.DetailList.length > 0) {
    this.modelData.MainList.DetailList[0].ShowOnFirstPage = v;
  }
}
}
